module.exports = __webpack_public_path__ + "static/media/video-placeholder.814993f9.jpg";